const categories = [
  { label: 'Ümumi', faqs: [
    { q: 'emailaze nədir?', a: 'emailaze Azərbaycan vətəndaşları üçün hazırlanmış müasir email hosting platformasıdır. AES-256 şifrələmə, üçdilli interfeys və 99.9% uptime təklif edir.' },
    { q: 'Pulsuz plan nə qədər müddətə aiddir?', a: 'Pulsuz planımız müddətsizdir — ödəniş etmədən istifadə edə bilərsiniz.' },
    { q: 'emailaze-nin serverləri harada yerləşir?', a: 'Serverlərimiz Bakıda yerləşir. Bu Azərbaycan istifadəçiləri üçün minimum gecikmə təmin edir.' },
  ]},
  { label: 'Hesab', faqs: [
    { q: 'Şifrəmi unutdum, nə edim?', a: 'Giriş səhifəsindəki "Şifrəni unutmusunuz?" linkini klikləyin. Email ünvanınıza sıfırlama linki göndəriləcək.' },
    { q: 'Email ünvanımı dəyişdirə bilərəmmi?', a: 'Hal-hazırda email ünvanı dəyişdirilə bilmir. Yeni ünvan üçün yeni hesab yaradın.' },
  ]},
  { label: 'Ödəniş', faqs: [
    { q: 'Hansı ödəniş üsulları qəbul edilir?', a: 'Visa, Mastercard, Kapital Bank kartları və yerli bank köçürməsi qəbul edilir.' },
    { q: 'İllik plana keçsəm geri ödəniş olurmu?', a: 'İlk 30 gün ərzində tam geri ödəniş edilir.' },
  ]},
  { label: 'Texniki', faqs: [
    { q: 'IMAP/SMTP ayarları necədir?', a: 'IMAP: imap.emailaze.com:993 (SSL), SMTP: smtp.emailaze.com:587 (TLS).' },
    { q: 'Xüsusi domenimi necə əlavə edim?', a: 'Hesab > Domenlər > Domen Əlavə Et bölmərindən DNS ayarlarınızı daxil edin.' },
  ]},
];

export default function FAQAccordion() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  return (
    <section className="py-16 px-4 bg-slate-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-display text-3xl font-bold text-slate-900 mb-2">{t('support.faq_title')}</h2>
          <p className="text-slate-500">{t('support.faq_subtitle')}</p>
        </div>
        <div className="flex gap-2 flex-wrap mb-8">
          {categories.map((cat, i) => (
            <button key={i} onClick={() => { setActiveTab(i); setOpenIdx(null); }}
              className={`px-4 py-2 rounded-full text-sm font-semibold transition-all ${activeTab === i ? 'bg-primary-600 text-white' : 'bg-white text-slate-600 border border-slate-200 hover:border-primary-300'}`}>
              {cat.label}
            </button>
          ))}
        </div>
        <div className="space-y-3">
          {categories[activeTab].faqs.map((faq, i) => (
            <div key={i} className="bg-white rounded-xl border border-slate-200 overflow-hidden">
              <button onClick={() => setOpenIdx(openIdx === i ? null : i)} className="w-full flex items-center justify-between px-5 py-4 text-left">
                <span className="font-medium text-slate-900 text-sm">{faq.q}</span>
                <svg className={`w-4 h-4 text-slate-400 flex-shrink-0 ml-4 transition-transform ${openIdx === i ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
              </button>
              {openIdx === i && <div className="px-5 pb-4 text-slate-500 text-sm leading-relaxed">{faq.a}</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
